import React from 'react';
import { Box, Typography, Badge } from '@mui/material';
import { Link } from 'react-router-dom';
import Searchbar from '../searchbar/Searchbar';
import Logo from '../../assets/images/Home/Logo.png';
import MessageIcon from '../../assets/icons/NavbarIcon/Message Icon.png';
import ShopIcon from '../../assets/icons/NavbarIcon/Shop.png';
import UserIcon from '../../assets/icons/NavbarIcon/UserIcon.png';
import Wishtlist from '../../assets/icons/NavbarIcon/Wishtlist.png';
// import './Navbar.css';
import Submitbtn from '../buttons/Submitbtn';

import { useNavigate } from 'react-router-dom';
import { useNavbarShopViewModel } from '../../viewModel/Shop/useNavbarShopViewModel';
import { useUnreadCount } from '../../hooks/useUnreadCount';
import { useCartSummary } from '../../hooks/shop/useCart';
import { useWishlist } from '../../hooks/shop/useProduct';

const ShopDropdown = () => {
  const {
    categories,
    categoriesLoading,
    hoveredCategory,
    setHoveredCategory,
    subcategories,
    subsLoading
  } = useNavbarShopViewModel();

  const [hoverOffset, setHoverOffset] = React.useState(0);

  const handleMouseEnter = (e, category) => {
    setHoveredCategory(category);
    const parent = e.currentTarget.parentElement;
    if (parent) {
      setHoverOffset(e.currentTarget.offsetTop - parent.scrollTop);
    } else {
      setHoverOffset(e.currentTarget.offsetTop);
    }
  };

  return (
    <Box className="shop-mega-menu" onMouseLeave={() => setHoveredCategory(null)}>
      <Box className="dropdown-content shop-main-list">
        {categoriesLoading ? (
          <Box sx={{ p: 2, fontSize: '12px', color: 'gray' }}>Loading Categories...</Box>
        ) : (
          categories.map(category => (
            <Box 
              key={category.ID} 
              onMouseEnter={(e) => handleMouseEnter(e, category)}
              className="shop-category-item"
            >
              <Link to={`/shop/${category.ID}`}>{category.Category}</Link>
            </Box>
          ))
        )}
      </Box>
      
      {hoveredCategory && (
        <Box 
          className="shop-sub-list dropdown-content" 
          sx={{ 
            marginTop: `${hoverOffset}px`,
            transition: 'margin-top 0.2s ease-in-out' // Smooth transition when switching categories
          }}
        >
          {subsLoading && <Box sx={{ p: 2, fontSize: '12px', color: 'gray' }}>Loading...</Box>}
          {!subsLoading && subcategories.map(sub => (
            <Link key={sub.ID} to={`/shop/${hoveredCategory.ID}/${sub.ID}`} onClick={()=>{setHoveredCategory(null)}}>{sub.SUBCATG}</Link>
          ))}
          {!subsLoading && subcategories.length === 0 && (
             <Box sx={{ p: 2, fontSize: '12px', color: 'gray' }}>No subcategories</Box>
          )}
        </Box>
      )}
    </Box>
  );
};

function Navbar({ isAuthenticated, setIsAuthenticated, isApproved }) {
  const navigate = useNavigate();
  const unreadCount = useUnreadCount(isAuthenticated && isApproved);
  const { data: cartSummary } = useCartSummary({ enabled: !!(isAuthenticated && isApproved) });
  const cartCount = cartSummary?.cnt || 0;
  const { data: wishlistItems = [] } = useWishlist({ enabled: !!(isAuthenticated && isApproved) });
  const wishlistCount = wishlistItems?.length || 0;

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <>
      <Box sx={{
        width: "100%",
        height: "15vh",
        backgroundColor: "#fff",
        display: { md: "flex", xs: "none" },
        justifyContent: "center",
        position: "fixed",
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
        zIndex: "10",
      }}>
        <Box sx={{
          width: "35%",
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <Link to="/" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>Home</Typography>
          </Link>

          {isAuthenticated && isApproved && (
            <Box className="dropdown">
              <Link to="/shop" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
                <Typography sx={{ cursor: "pointer", color: "rgba(45, 44, 44, 1)" }}>
                  Shop
                </Typography>
              </Link>
              <ShopDropdown />
            </Box>
          )}

          <Link to="/catalogues" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>Catalogues</Typography>
          </Link>
          <Link to="/About" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>About Us</Typography>
          </Link>
          <Link to="/Contactus" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>Contact Us</Typography>
          </Link>
        </Box>
        <Box sx={{
          width: "20%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Box sx={{ height: "60%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Link to="/" style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
              <img
                src={Logo}
                alt="Logo"
                style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
              />
            </Link>
          </Box>
        </Box>
        {isAuthenticated ? (
          <>
            <Box sx={{
              width: "20%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              marginRight: "2%",
            }}>
              {isApproved && <Searchbar />}
            </Box>
            <Box sx={{
              width: "15%",
              height: "100%",
              display: "flex",
              justifyContent: isApproved ? "space-between" : "flex-end",
              alignItems: "center",
            }}>
              {isApproved && (
                <>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Link to="/Wishlist" style={{ display: 'flex', alignItems: 'center' }}>
                      <Badge 
                        badgeContent={wishlistCount} 
                        max={99}
                        sx={{
                          '& .MuiBadge-badge': {
                            backgroundColor: 'rgba(105, 83, 55, 1)',
                            color: 'white',
                            fontWeight: 700,
                            fontSize: '0.72rem',
                            height: '18px',
                            minWidth: '18px',
                            padding: '0 4px',
                          }
                        }}
                      >
                        <img src={Wishtlist} alt="" width="70%" style={{ display: 'block' }} />
                      </Badge>
                    </Link>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Link to="/Cart" style={{ display: 'flex', alignItems: 'center' }}>
                      <Badge 
                        badgeContent={cartCount} 
                        max={99}
                        sx={{
                          '& .MuiBadge-badge': {
                            backgroundColor: 'rgba(105, 83, 55, 1)',
                            color: 'white',
                            fontWeight: 700,
                            fontSize: '0.72rem',
                            height: '18px',
                            minWidth: '18px',
                            padding: '0 4px',
                          }
                        }}
                      >
                        <img src={ShopIcon} alt="" width="70%" style={{ display: 'block' }} />
                      </Badge>
                    </Link>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Link to="/chat" style={{ display: 'flex', alignItems: 'center' }}>
                      <Badge 
                        badgeContent={unreadCount} 
                        max={99}
                        sx={{
                          '& .MuiBadge-badge': {
                            backgroundColor: '#695337',
                            color: 'white',
                            fontWeight: 700,
                            fontSize: '0.72rem',
                            height: '18px',
                            minWidth: '18px',
                            padding: '0 4px',
                          }
                        }}
                      >
                        <img src={MessageIcon} alt="" width="70%" style={{ display: 'block' }} />
                      </Badge>
                    </Link>
                  </Box>
                </>
              )}
              <Box className="user-dropdown">
                <img src={UserIcon} alt="" width="70%" />
                <Box className="user-dropdown-content">
                  {isApproved && (
                    <>
                      <Link to="/profile">Profile</Link>
                      <Link to="/myquotations">My Quotations</Link>
                      <Link to="/myorder">My Orders</Link>
                    </>
                  )}
                  <Typography
                    onClick={handleLogout}
                    sx={{
                      padding: "12px 16px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f1f1f1",
                        color: "rgba(105, 83, 55, 1)"
                      },
                      fontSize: "14px",
                      color: "black"
                    }}
                  >
                    Logout
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              width: "37%",
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "20px",
            }}>
              <Box>
                <Link to="/login" style={{ textDecoration: 'none' }}>
                  <Submitbtn name={"Login"} color={"white"} borderRadius={"20px"} width={"120px"} />
                </Link>
              </Box>
              <Box>
                <Link to="/register" style={{ textDecoration: 'none' }}>
                  <Submitbtn name={"Signup"} color={"white"} borderRadius={"20px"} width={"120px"} />
                </Link>
              </Box>
            </Box>
          </>
        )}
      </Box>

      <Box sx={{
        width: "100%",
        height: "15vh",
        display: { md: "flex", xs: "none" }
      }}></Box>
    </>
  );
}

export default Navbar;
